var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseMatchupBlock',{attrs:{"primary-type":_vm.form.primaryType,"secondary-type":_vm.form.secondaryType},scopedSlots:_vm._u([{key:"defender-info",fn:function(){return [_c('defender-info',{attrs:{"species":_vm.species,"form":_vm.form}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }